{
  "hero": {
    "eyebrow": "加入",
    "title": "在真实的校园可持续挑战中锻炼监测技能。",
    "lead": "机械、电气、软件与商务方向的学生共同规划、设计、测试、记录并传播 AquaWorks。"
  },
  "paths": {
    "title": "参与方式",
    "items": {
      "students": {
        "title": "作为学生加入",
        "body": "参与软件、电气、机械或商务工作流——从 CAD 与电路到数据可视化、采购与报告。"
      },
      "partners": {
        "title": "顾问或合作",
        "body": "教师、实验室与校园伙伴可指导方法、场地可行性与负责任沟通。我们已咨询 Campus and Community Planning 与土木工程相关教师。"
      },
      "public": {
        "title": "关注建造过程",
        "body": "阅读动态了解里程碑，浏览科学页了解指标与校园背景，或在受控测试后关注公开演示。"
      }
    }
  },
  "contacts": {
    "title": "主要联系人",
    "body": "团队加入、合作或第一阶段相关问题，请联系项目负责人。",
    "items": [
      {
        "name": "Jiaming Han",
        "role": "项目负责人 · 应用科学学院",
        "email": "jhan31@student.ubc.ca"
      },
      {
        "name": "Lucas Lyu",
        "role": "联合项目负责人 · 应用科学学院",
        "email": "lyuchongkai@gmail.com"
      }
    ],
    "note": "仅公开项目负责人邮箱。电话与学号不在本站发布。"
  }
}
